export const DATE_RANGE_FIELDS = {
  END: "endDate",
  START: "startDate",
} as const;

export const DATE_RANGE_REQUEST_FIELDS = {
  END: "end_date",
  START: "start_date",
} as const;

export type DateRangeValue<T = Date | null> = {
  [DATE_RANGE_FIELDS.START]: T;
  [DATE_RANGE_FIELDS.END]: T;
};

type CompleteDateRangeValue = DateRangeValue<Date>;

export const createEmptyDateRange = (): DateRangeValue => ({
  [DATE_RANGE_FIELDS.START]: null,
  [DATE_RANGE_FIELDS.END]: null,
});

export const getDateRangeFromPicker = (
  value: [Date, Date] | null | undefined,
): DateRangeValue => ({
  [DATE_RANGE_FIELDS.START]: value?.[0] || null,
  [DATE_RANGE_FIELDS.END]: value?.[1] || null,
});

export const isDateRangeComplete = (
  dateRange: DateRangeValue,
): dateRange is CompleteDateRangeValue =>
  !!dateRange?.[DATE_RANGE_FIELDS.START] && !!dateRange?.[DATE_RANGE_FIELDS.END];

export const isDateRangeInvalid = (dateRange: DateRangeValue) =>
  isDateRangeComplete(dateRange) &&
  dateRange[DATE_RANGE_FIELDS.END] < dateRange[DATE_RANGE_FIELDS.START];

const toRequestDate = (value: Date) => {
  const date = new Date(value);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
};

export const buildDateRangePayload = (dateRange: DateRangeValue) => {
  if (!isDateRangeComplete(dateRange) || isDateRangeInvalid(dateRange)) {
    return {};
  }

  return {
    [DATE_RANGE_REQUEST_FIELDS.START]: toRequestDate(
      dateRange[DATE_RANGE_FIELDS.START],
    ),
    [DATE_RANGE_REQUEST_FIELDS.END]: toRequestDate(
      dateRange[DATE_RANGE_FIELDS.END],
    ),
  };
};
